export default "__VITE_ASSET__DZcT8G3K__"